import type { FC, ReactNode } from "react";
import { Fragment } from "react";
import Date, { DateProps } from "../atom/date";

type Props = DateProps & {
  label?: ReactNode;
  placeholder?: ReactNode;
};

const DefaultPlaceholder = <span className="flag default">Chưa duyệt</span>;

export const ApprovedDate: FC<Props> = (props) => {
  const { value, label = "Ngày duyệt", placeholder = DefaultPlaceholder } = props;

  if (!value) {
    return <Fragment>{placeholder}</Fragment>;
  }

  return (
    <Fragment>
      {label}: <Date value={value} />
    </Fragment>
  );
};
